import {InformationTypeEnum} from '../../enums/information-type.enum';
import {BaseActionDto} from './BaseActionDto.model';

export class RequestInformationActionDto extends BaseActionDto {

  "informationType": InformationTypeEnum;
  "documentTitle": string;

  constructor(data: any) {
    super(data);
    this.informationType = data.informationType;
    this.documentTitle = data.documentTitle;
  }
}
